import OpenInNewIcon from '@material-design-icons/svg/filled/open_in_new.svg?react';
import { getHubspotTicketUrl } from '../../../../lib/hubspot-management/formatters';
import { getRequestTypeDisplay } from '../../../../utils/hubspotUtils';
import { Field, FieldGrid } from '../../../common/detailParts';
import { PanelSection } from '../../PanelSection';
import {
  getTicketGeofilteringDisplay,
  type TicketGeofilteringMode,
} from './geofiltering';

interface HubspotTicketDetailsSectionProps {
  hubspotId: string;
  subject: string | null;
  content: string | null;
  requestType: string | null;
  priority: string | null;
  availableCountriesMode: TicketGeofilteringMode;
  availableCountries: string[];
}

export function HubspotTicketDetailsSection({
  hubspotId,
  subject,
  content,
  requestType,
  priority,
  availableCountriesMode,
  availableCountries,
}: HubspotTicketDetailsSectionProps) {
  const geofiltering = getTicketGeofilteringDisplay(
    availableCountriesMode,
    availableCountries,
  );

  return (
    <PanelSection
      title="Ticket"
      trailing={
        <a
          href={getHubspotTicketUrl(hubspotId)}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 font-mono text-xs text-teal-300 transition-colors hover:text-teal-200"
        >
          #{hubspotId}
          <OpenInNewIcon className="size-3.5 fill-current" />
        </a>
      }
    >
      <FieldGrid cols={2}>
        <Field label="Subject" className="sm:col-span-2">
          {subject ?? '—'}
        </Field>
        <Field label="Request">{getRequestTypeDisplay(requestType).text}</Field>
        <Field label="Priority">{priority ?? '—'}</Field>
        {geofiltering && (
          <Field label="Geofiltering" className="sm:col-span-2">
            <div>{geofiltering.label}</div>
            <div className="mt-1 whitespace-pre-wrap text-neutral-300">
              {geofiltering.countryNames}
            </div>
          </Field>
        )}
      </FieldGrid>
      {content && (
        <div className="mt-5 border-t border-white/5 pt-4">
          <div className="mb-1.5 text-[10.5px] font-medium uppercase tracking-[0.08em] text-neutral-500">
            Content
          </div>
          <pre className="whitespace-pre-wrap font-sans text-sm leading-relaxed text-neutral-300">
            {content}
          </pre>
        </div>
      )}
    </PanelSection>
  );
}
